import React from 'react';
import Card from '../Card/Card';
import './RadioCardItem.less';
import { getLightBrandColor } from 'getaway-data-layer';

type Props = {
  title: string;
  selected?: boolean;
  onClick: () => void;
  firstItem?: boolean;
  lastItem?: boolean;
  testid?: string;
};

const RadioCardItem = ({
  title,
  selected,
  onClick,
  firstItem,
  lastItem,
  testid,
}: Props) => {
  return (
    <Card hideShadow={true} firstItem={firstItem} lastItem={lastItem}>
      <div
        data-testid={`CardItem-${testid}`}
        className="radio-card-item-container"
        onClick={onClick}
        style={selected ? { backgroundColor: getLightBrandColor() } : {}}
      >
        <div className="radio-card-item-title">{title}</div>
        <div className="radio-card-item-radio-wrapper">
          <input
            type="radio"
            id="radioButton"
            name="radioGroup"
            className="radio-card-item-radio"
            checked={selected}
          />
        </div>
      </div>
    </Card>
  );
};

RadioCardItem.defaultProps = {};

export default RadioCardItem;
